// extracted by mini-css-extract-plugin
export default {"wrapper":"DialogOpened_wrapper__Ghmh+"};